import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'
import preloader from '@/components/preloader'

function renderPreloader(h) {
  if (this.loading) {
    return h(
      'div',
      {
        class: 'px-2'
      },
      [
        h(
          preloader,
          {
            props: {
              size: 16
            }
          }
        )
      ]
    )
  }
}
function renderInput(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.code,
        label: this.getTranslate(`${Services['otp-verification']}.labels.code`),
        hint: this.attemptsInfo,
        error: this.codeError,
        mask: this.codeMask,
        disabled: this.loading,
        defaultValue: '',
        trim: true,
        dense: true,
        details: true
      },
      on: {
        input: event => {
          this.code = event
          this.codeError = ''
        },
        keypress: event => {
          if (event.key === 'Enter' && !this.checkCodeDisabled) {
            this.checkCode()
          }
        }
      }
    }
  )
}
function renderConfirmButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.confirm'),
        color: Colors.primary,
        loading: this.loadingCodeCheck || this.loadingComplete,
        disabled: this.checkCodeDisabled
      },
      on: {
        click: () => {
          this.checkCode()
        }
      }
    }
  )
}
function renderCodeInput(h) {
  if (this.showCodeInput) {
    return h(
      'div',
      {
        class: 'grid grid-gap--8',
        style: { 'grid-template-columns': '1fr auto' }
      },
      [
        renderInput.call(this, h),
        renderConfirmButton.call(this, h)
      ]
    )
  }
}
function renderError(h) {
  if (this.error) {
    return h(
      info,
      {
        props: {
          value: this.error,
          color: Colors.error
        }
      }
    )
  }
}
function renderDescription(h) {
  if (this.statusInfo) {
    return h(
      info,
      {
        props: {
          value: this.statusInfo
        }
      }
    )
  }
}
function renderSuccess(h) {
  if (this.successInfo) {
    return h(
      info,
      {
        props: {
          value: this.successInfo,
          color: Colors.success
        }
      }
    )
  }
}
function renderCodeLifetimeInfo(h) {
  if (this.showCodeLifetimeInfo) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${Services['otp-verification']}.hints.codeLifetime`, { count: this.codeLifetimeSeconds })
        }
      }
    )
  }
}
function renderContent(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      renderCodeInput.call(this, h),
      renderCodeLifetimeInfo.call(this, h)
    ].filter(Boolean)
  )
}
function renderBody(h) {
  return h(
    'div',
    {
      class: {
        'px-2': true,
        'pt-2': this.showCodeInput
      }
    },
    [
      renderError.call(this, h) ??
      renderSuccess.call(this, h) ??
      renderDescription.call(this, h) ??
      renderContent.call(this, h)
    ].filter(Boolean)
  )
}

function renderCloseButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.close'),
        mode: buttonModes.flat
      },
      on: {
        click: () => {
          this.eventHandler(false)
        }
      }
    }
  )
}
function renderResendButton(h) {
  if (this.isCodeSended && this.canContinueVerification && !this.remainingCodeAttemptsExhausted) {
    return h(
      button,
      {
        props: {
          label: this.getTranslate('misc.buttons.resend'),
          mode: buttonModes.flat,
          disabled: !this.resendDisabled
        },
        on: {
          click: () => {
            this.resend()
          }
        }
      }
    )
  }
}
function renderFooterLeft(h) {
  return h(
    'div',
    {
      class: 'dialog__footer-left'
    },
    [ renderPreloader.call(this, h) ].filter(Boolean)
  )
}
function renderFooterRight(h) {
  return h(
    'div',
    {
      class: 'dialog__footer-right'
    },
    [
      renderResendButton.call(this, h),
      renderCloseButton.call(this, h)
    ].filter(Boolean)
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer dialog__footer--between',
      slot: 'footer'
    },
    [
      renderFooterLeft.call(this, h),
      renderFooterRight.call(this, h)
    ]
  )
}

export default function(h) {
  let maxWidth
  if (this.viewport.breakpoint.mdUp) {
    maxWidth = 400
  }

  return h(
    components.dialog,
    {
      props: {
        value: this.proxy,
        title: this.getTranslate(`${Services['otp-verification']}.title`),
        maxWidth
      },
      on: {
        input: event => {
          this.eventHandler(event)
        }
      }
    },
    [
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
